import {BoundCardModal} from '@logistics-frontend/bound-card/mobile'
import React from 'react'

import {useChangePaymentCardModal} from './hooks'
import {ChangePaymentCardModalProps} from './types'

export const ChangePaymentCardModal = (props: ChangePaymentCardModalProps): React.ReactElement | null => {
  const {paymentCard, onChange, onClose, opened} = props
  const {fetchBindingUrl, fetchCards, fetchBoundCard} = useChangePaymentCardModal(props)

  // BoundCardModal всегда opened, независимо от переданного пропа
  if (!opened) {
    return null
  }

  return (
    <BoundCardModal
      card={paymentCard}
      fetchBindingUrl={fetchBindingUrl}
      fetchBoundCard={fetchBoundCard}
      fetchCards={fetchCards}
      onClose={onClose}
      onSuccess={onChange}
    />
  )
}
